(() => {
  const sizeRanges = [
    { label: 'XS', max: 86 },
    { label: 'S', max: 94 },
    { label: 'M', max: 102 },
    { label: 'L', max: 112 },
    { label: 'XL', max: 123 },
    { label: 'XXL', max: 136 },
  ];

  const parseMeasure = (input) => {
    const value = Number.parseFloat(input.value);
    return Number.isFinite(value) && value > 0 ? value : 0;
  };

  const recommendSize = ({ height, chest, waist, hips }) => {
    let score = Math.max(chest, waist ? waist + 14 : 0, hips);

    if (!score && height) {
      score = height < 168 ? 88 : height > 184 ? 108 : 98;
    }

    if (!score) {
      return null;
    }

    let index = sizeRanges.findIndex((range) => score <= range.max);

    if (index === -1) {
      index = sizeRanges.length - 1;
    }

    if (height >= 188 && index < sizeRanges.length - 1) {
      index += 1;
    }

    if (height > 0 && height <= 160 && index > 0) {
      index -= 1;
    }

    return sizeRanges[index].label;
  };

  const enhanceRecommender = (root) => {
    if (root.dataset.insoemEnhanced === 'true') {
      return;
    }

    root.dataset.insoemEnhanced = 'true';

    const form = root.querySelector('[data-insoem-size-form]');
    const result = root.querySelector('[data-insoem-size-result]');
    const clear = root.querySelector('[data-insoem-size-clear]');

    if (!form || !result) {
      return;
    }

    const getPayload = () => {
      const height = parseMeasure(root.querySelector('[data-insoem-measure="height"]'));
      const chest = parseMeasure(root.querySelector('[data-insoem-measure="chest"]'));
      const waist = parseMeasure(root.querySelector('[data-insoem-measure="waist"]'));
      const hips = parseMeasure(root.querySelector('[data-insoem-measure="hips"]'));

      return { height, chest, waist, hips };
    };

    const update = () => {
      const size = recommendSize(getPayload());

      if (!size) {
        result.textContent = 'Agrega al menos una medida para recibir una talla orientativa.';
        return;
      }

      if (root.dataset.insoemFitFeed === 'true') {
        result.textContent = `Talla orientativa para empezar: ${size}. Usa esta guía para explorar tops, pantalones, sneakers u outfits demo; la tabla final debe validarse con datos reales de LACEUP.`;
        return;
      }

      result.textContent = `Talla sugerida para empezar: ${size}. Revisa siempre el fit deseado y la tabla final del producto antes de comprar.`;
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      update();
    });

    clear?.addEventListener('click', () => {
      form.reset();
      result.textContent = 'Tus medidas no se guardan ni se envían. El cálculo ocurre solo en tu navegador.';
    });
  };

  const init = () => {
    document.querySelectorAll('[data-insoem-size-recommender]').forEach(enhanceRecommender);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
